import { useParams } from "react-router-dom";
import { ItemCreateMediaProvider } from "./contexts/ItemCreateMediaContext";
import { ItemVariantDraftProvider } from "./contexts/ItemVariantDraftContext";
import { ItemDetailContent } from "./ItemDetailContent";

/**
 * Item Detail Page — thin wrapper around ItemDetailContent.
 *
 * Reads route params and renders ItemDetailContent in "page" mode.
 * Both modes wrap with ItemVariantDraftProvider.
 * Create mode additionally wraps with ItemCreateMediaProvider.
 *
 * The actual content lives in ItemDetailContent.tsx which is shared
 * between this full-page route and the slide-over DetailPanel.
 */
export function ItemDetailPage() {
  const params = useParams<{ name?: string; id?: string }>();
  const itemName = params.name || params.id || "";
  const isNew = !itemName || itemName === "new";

  if (isNew) {
    return (
      <ItemCreateMediaProvider>
        <ItemVariantDraftProvider>
          <ItemDetailContent itemName="" />
        </ItemVariantDraftProvider>
      </ItemCreateMediaProvider>
    );
  }

  return (
    <ItemVariantDraftProvider>
      <ItemDetailContent itemName={itemName} />
    </ItemVariantDraftProvider>
  );
}
